import { alpha, makeStyles } from "@material-ui/core"

export const NotesStyle = makeStyles((theme) => ({
    noteWrapper: {
        //minWidth:"400px",
        background: '#f3f3f3',
        borderRadius: '5px',
        padding: '0.5em 0.75em',
        '&:hover': {
            '&  $noteActions': {
                opacity: 1
            }
        },
    },
    hotNoteWrapper: {
        background: alpha(theme.palette.warning.main, 0.12),
        border: `1px solid ${alpha(theme.palette.warning.main, 0.5)}`,
    },
    hotNoteIcon: {
        fill: theme.palette.warning.dark,
        display: 'block',
        fontSize: '1rem',
    },
    title: {
        fontSize: '1.5em',
        cursor: 'pointer',
        fontWeight: 500
    },
    commentIcon: {
        marginRight: '0.2em'
    },
    noCollapseNoteList: {
        minHeight: '100px'
    },
    notesTooltip: {
        opacity: 0.2,
        transition: 'opacity 0.2s ease',
        '&:hover': {
            opacity: 1
        },
    },
    notesTooltipOn: {
        opacity: 0.7,
    },
    noteActions: {
        transition: 'opacity 0.2s ease',
        opacity: 0,
    },
    noteListWrapper: {
        padding: '1em 0'
    },
    titleText: {
        padding: '0 0.5rem'
    },
    noteFilterBar: {
        paddingBottom: '0.5em',
    },
    noteFilterChip: {
        fontWeight: 500,
        borderRadius: '16px',
        '& .MuiChip-icon': {
            color: 'inherit',
            fill: 'currentColor',
        },
    },
    noteFilterChipDefault: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
        '&&:focus': {
            backgroundColor: 'transparent',
        },
        '&&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
        },
    },
    noteFilterChipDefaultSelected: {
        '&&': {
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
        },
        '&&:hover, &&:focus': {
            backgroundColor: alpha(theme.palette.primary.main, 0.2),
        },
    },
    noteFilterChipHot: {
        color: theme.palette.warning.dark,
        borderColor: theme.palette.warning.main,
        '&&:focus': {
            backgroundColor: 'transparent',
        },
        '&&:hover': {
            backgroundColor: alpha(theme.palette.warning.main, 0.1),
        },
    },
    noteFilterChipHotSelected: {
        '&&': {
            backgroundColor: alpha(theme.palette.warning.main, 0.15),
        },
        '&&:hover, &&:focus': {
            backgroundColor: alpha(theme.palette.warning.main, 0.25),
        },
    }
}));